module.exports = require('./components/statusmessage');
